
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {IAntiTheft} from "@/modules/CarList/interfaces/anti-theft.interface";
  import CarNumber from "@/components/CarNumber.vue";
  import ShortCarSecurity from "@/modules/CarList/components/AntiTheftComponents/ShortCarSecurity.vue";
  import _ from "lodash";
  import {isMobile} from "mobile-device-detect";

  @Component({
    components: {
      CarNumber,
      AppDialog,
      ShortCarSecurity,
    },
  })
  export default class AntiTheftCarsPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'allPages', dialogName: 'antiTheftCars' };
    cars: IAntiTheft.IStatusCars[] = [];

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    created() {
      this.cars = this.payloadPopup.cars;
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
